import React, { ReactElement, useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import ContactsGrid from "../../components/yenimahalle/ContactsGrid";
import PortalPeopleApi from "../../api/PortalPeopleApi";
import { MeclisUyeleriList, MuhtarList } from "../../models/Response/PortalPeople";
import { Phone } from "react-feather";

// ContactsGrid için kullanılacak card arayüzü
interface Card {
  imageSrc: string;
  title: string;
  description: ReactElement;
  titleText: string;
  phoneNumber:string;
}

const Muhtarlar: React.FC = () => {
  const [cards, setCards] = useState<Card[]>([]);

  useEffect(() => {
    // API'den meclis üyeleri verisini çekiyoruz
    const fetchData = async () => {
      const response = await PortalPeopleApi.getMuhtarlar();
      if (response && response.content.muhtarList) {
        const mappedCards = response.content.muhtarList.map((item: MuhtarList) => ({
          imageSrc: item.imageUrl,
          title: item.nameSurname,
          description: (
            <>
              <strong>{item.mahalleName}</strong>
              <br />
              <i>{item.address}</i>
            </>
          ),
          titleText: "",
          phoneNumber: item.phone,
        }));
        setCards(mappedCards);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout>
      <BasicHeader headingLine1="" headingLine2="Muhtarlar" />
      <ContactsGrid cards={cards} showTitleText={false} />
    </Layout>
  );
};

export default Muhtarlar;
